export default {
  template: 1,
  bussiness_card: 2,
  export_xlsx: 5,
};
